import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var EVENTS_ENDPOINTS = {
    BY_EVENT_ID: '/api/v1/Events/GetByEventId',
    BY_LEAGUE_ID: '/api/v1/Events/GetByLeagueId',
    BY_SPORT_ID: '/api/v1/Events/GetBySportId',
    FROM_TOP_LEAGUES_BY_SPORT_ID: '/api/v1/Events/GetFromTopLeaguesBySportId'
};
/**
 * LeaguesApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class LeaguesApiClient
 * @extends {BaseApiClient}
 */
var EventsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(EventsApiClient, _super);
    function EventsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch events by ids from BFF
     * @param {request} EventsByEventIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByEventsId = function (request) {
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID, request);
    };
    /**
     * Fetch events by league ids from BFF
     * @param {request} EventsByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByLeaguesId = function (request) {
        return this.executeRequest(EVENTS_ENDPOINTS.BY_LEAGUE_ID, request);
    };
    /**
     * Fetch events by sport ids from BFF
     * @param {request} EventsBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getBySportId = function (request) {
        return this.executeRequest(EVENTS_ENDPOINTS.BY_SPORT_ID, request);
    };
    /**
     * Fetch events from top leagues by sport id from BFF
     * @param {request} EventsFromTopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getFromTopLeaguesBySportId = function (request) {
        return this.executeRequest(EVENTS_ENDPOINTS.FROM_TOP_LEAGUES_BY_SPORT_ID, request);
    };
    return EventsApiClient;
}(BaseApiClient));
export { EventsApiClient };
//# sourceMappingURL=EventsApiClient.js.map